<template>
    <div class="home-intro">
        <div class="home-intro__tab-head">
            <ul>
                <li @click="openTabContent('damen')" class="home-intro__tab" :class="{'home-intro__tab--active' : damenContentVisible }">DAMEN</li>
                <li @click="openTabContent('herren')" class="home-intro__tab" :class="{'home-intro__tab--active' : herrenContentVisible }">HERREN</li>
                <li @click="openTabContent('trends')" class="home-intro__tab" :class="{'home-intro__tab--active' : trendsContentVisible }">TRENDS</li>
            </ul>
        </div>
        <div class="home-intro__tab-content-wrapper">
            <div class="home-intro__tab-content home-intro__tab-content--damen" ref="damenContent" v-show="damenContentVisible">
                <div v-for="cat in slidestab1" class="home-intro__tab-content-box">
                    <a :href="cat.url" :title="cat.name" class="d-block">
                        <div class="home-intro__tab-content-img" v-if="cat.customImageUrl != '' && typeof cat.customImageUrl != 'undefined'">
                            <lazy-img
                                    picture-class=""
                                    :image-url="cat.customImageUrl"
                                    :alt="cat.name"
                                    :title="cat.name">
                            </lazy-img>
                        </div>
                        <div class="home-intro__tab-content-img" v-else>
                            <lazy-img v-if="getImageUrl(cat) != ''"
                                      picture-class=""
                                      :image-url="getImageUrl(cat)"
                                      :alt="cat.name"
                                      :title="cat.name">
                            </lazy-img>
                        </div>
                        <div class="home-intro__tab-content-txt">
                            {{ cat.name }}
                        </div>
                    </a>
                </div>
            </div>
            <div class="home-intro__tab-content home-intro__tab-content--herren" ref="herrenContent" v-show="herrenContentVisible">
                <div v-for="cat in slidestab2" class="home-intro__tab-content-box">
                    <a :href="cat.url" :title="cat.name" class="d-block">
                        <div class="home-intro__tab-content-img">
                            <lazy-img v-if="getImageUrl(cat) != ''"
                                    picture-class=""
                                    :image-url="getImageUrl(cat)"
                                    :alt="cat.name"
                                    :title="cat.name">
                            </lazy-img>
                        </div>
                        <div class="home-intro__tab-content-txt">
                            {{ cat.name }}
                        </div>
                    </a>
                </div>
            </div>
            <div class="home-intro__tab-content home-intro__tab-content--trends" ref="trendsContent" v-show="trendsContentVisible">
                <div v-for="cat in slidestab3" class="home-intro__tab-content-box">
                    <a :href="cat.url" :title="cat.name" class="d-block">
                        <div class="home-intro__tab-content-img">
                            <!-- cat.imageUrl === '/documents/' ? cat.image2Url : cat.imageUrl -->
                            <lazy-img v-if="getImageUrl(cat) != ''"
                                      picture-class=""
                                    :image-url="getImageUrl(cat)"
                                    :alt="cat.name"
                                    :title="cat.name">
                            </lazy-img>
                        </div>
                        <div class="home-intro__tab-content-txt">
                            {{ cat.name }}
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
            slidestab1: {
                type: Array,
                default: () => []
            },
            slidestab2: {
                type: Array,
                default: () => []
            },
            slidestab3: {
                type: Array,
                default: () => []
            }
        },

        data()
        {
            return {
                damenContentVisible: true,
                herrenContentVisible: false,
                trendsContentVisible: false
            };
        },

        methods:{
            openTabContent(type){
                switch (type){
                    case "damen":
                        this.herrenContentVisible = false;
                        this.trendsContentVisible = false;
                        this.damenContentVisible = true;

                        break;
                    case "herren":
                        this.herrenContentVisible = true;
                        this.trendsContentVisible = false;
                        this.damenContentVisible = false;
                        break;
                    case "trends":
                        this.herrenContentVisible = false;
                        this.trendsContentVisible = true;
                        this.damenContentVisible = false;
                        break;
                }
            },

            getImageUrl(cat){
                let ret;
                if(typeof cat.image2Url !== "undefined" && cat.image2Url !== "/documents/"){
                    ret = cat.image2Url;
                }else if(typeof cat.imageUrl !== "undefined" && cat.imageUrl !== "/documents/"){
                    ret = cat.imageUrl;
                }
                else if(cat.imageUrl == "/documents/"){
                    if( cat.image2Url == "/documents/"){
                        ret = "";
                    }else{
                        ret = cat.image2Url;
                    }
                }else if(cat.imageUrl != "/documents/"){
                    ret = cat.imageUrl;
                }else{
                    ret = "";
                }

                if(typeof ret === "undefined"){
                    ret = "";
                }

                return ret;
            }
        }
    }
</script>
